import lodash from "lodash";
import deepdash from "deepdash-es";
const _ = deepdash(lodash);

export const GetFormSchemaPath = (itemID: string, objectToSearch: any) => {
  const formItempath = _.findPathDeep(
    objectToSearch.formSchema,
    (value, key) => key === itemID,
    {
      //@ts-ignore
      childrenPath: "properties",
    }
  );

  return formItempath;
};
